// CHANGE THIS TO https://www.atomcms.dev/api
export const baseAPIRoute = 'https://cmsatom.netlify.app/api';
// export const baseAPIRoute = 'http://localhost:3000/api';
